import { O_USER_STATUS } from "@/src-refactor/modules/shared/model/const/users/status.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

export type agentAutoCompleteItem = I_GENERIC_ITEMS<{
  agentData: {
    name: string;
    id: string | number;
    picture: string;
    agencyName?: string;
    isSuspend?: boolean;
    isActive?: boolean;
    isInactive?: boolean;
    form?: any;
    role?: string;
  };
}>;

interface argAgentAutoCompleteItemAdapter {
  name: string;
  id: string | number;
  picture: string;
  agencyName?: string;
  status?: string;
  form?: any;
  role?: string;
}

const agentAutoCompleteItemAdapter: (
  arg: argAgentAutoCompleteItemAdapter
) => agentAutoCompleteItem = arg => {
  const status = O_USER_STATUS[arg.status ?? "error"].value;
  return {
    label: `${arg.name}`,
    value: arg.id,
    id: arg.id,
    name: arg.name,
    extraData: {
      agentData: {
        name: arg.name,
        id: arg.id,
        picture: arg.picture,
        agencyName: arg.agencyName,
        isSuspend: status === "suspend",
        isActive: status === "active",
        isInactive: status === "inactive",
        form: arg.form ?? null,
        role: arg.role
      }
    }
  } as agentAutoCompleteItem;
};

export { agentAutoCompleteItemAdapter };
